export default "__VITE_ASSET__Bgvk2$Ng__"